import { routePaths } from 'components/Routes/data';
import { useHistory } from 'react-router-dom';
import { salaryComponentParams } from '../constants';
import { EarningPayType, SalaryComponent } from '../types';

const createUrlParams = ({
  componentId,
  payType,
}: {
  componentId: string;
  payType?: EarningPayType;
}) => {
  const urlParams = new URLSearchParams({
    [salaryComponentParams.componentId]: componentId,
  });
  if (payType) {
    urlParams.set(salaryComponentParams.earningPayType, payType);
  }
  return urlParams;
};

export const useSalaryComponentHelpers = () => {
  const history = useHistory();

  const openEarningsCreation = () => {
    history.push(routePaths.salaryComponents.root);
  };

  const openDeductionsCreation = () => {
    history.push(routePaths.salaryComponents.deductionsListView);
  };
  const openEarningsEditPage = (componentId: string, payType?: EarningPayType) => {
    const urlParams = createUrlParams({ componentId, payType });
    history.push(`${routePaths.salaryComponents.edit.earnings.root}?${urlParams.toString()}`);
  };
  const openDeductionsEditPage = (componentId: string) => {
    const urlParams = createUrlParams({ componentId });
    history.push(`${routePaths.salaryComponents.edit.deductions.root}?${urlParams.toString()}`);
  };
  const openPredefinedEditPage = (componentId: string) => {
    const urlParams = createUrlParams({ componentId });
    history.push(`${routePaths.salaryComponents.edit.predefinedComponent}?${urlParams.toString()}`);
  };
  const openNonPayableBenefitsEditPage = (componentId: string) => {
    const urlParams = createUrlParams({ componentId });
    history.push(
      `${routePaths.salaryComponents.edit.nonPayableBenefits.root}?${urlParams.toString()}`,
    );
  };
  const openFlexibleBenefitsEditPage = (componentId: string) => {
    const urlParams = createUrlParams({ componentId });
    history.push(`${routePaths.flexibleBenefits.edit}?${urlParams.toString()}`);
  };

  const openPerquisitesEditPage = (componentId: string) => {
    const urlParams = createUrlParams({ componentId });
    history.push(`${routePaths.salaryComponents.edit.perquisites.root}?${urlParams.toString()}`);
  };

  const getDetailsViewURL = (component: SalaryComponent) => {
    const urlParams = createUrlParams({
      componentId: component.id,
      payType:
        component.category === 'EARNINGS_CATEGORY'
          ? component.settings.earningDetails.payType
          : undefined,
    });

    switch (component.category) {
      case 'EARNINGS_CATEGORY':
        if (component.settings.earningDetails.payType === 'non_payable_benefit') {
          return `${
            routePaths.salaryComponents.nonPayableBenefitsListView
          }?${urlParams.toString()}`;
        } else {
          return `${routePaths.salaryComponents.earningsListView}?${urlParams.toString()}`;
        }
      case 'DEDUCTIONS_CATEGORY':
        return `${routePaths.salaryComponents.deductionsListView}?${urlParams.toString()}`;
      case 'PERQUISITES_CATEGORY':
        return `${routePaths.salaryComponents.perquisitesListView}?${urlParams.toString()}`;
      default:
        return '';
    }
  };

  return {
    openEarningsCreation,
    openDeductionsCreation,
    openEarningsEditPage,
    openDeductionsEditPage,
    openPredefinedEditPage,
    openNonPayableBenefitsEditPage,
    openFlexibleBenefitsEditPage,
    openPerquisitesEditPage,
    getDetailsViewURL,
  };
};
